import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "../../../Loadable";

const HelpCenterTicket = Loadable(
  lazy(() => import("src/pages/communications/help-center/ticket/index"))
);
const TicketDashboard = Loadable(
  lazy(() =>
    import("src/pages/communications/help-center/ticket/ticketDashboard/index")
  )
);

const TicketDepartment = Loadable(
  lazy(() =>
    import("src/pages/communications/help-center/ticket/department/index")
  )
);
const TicketCategories = Loadable(
  lazy(() =>
    import("src/pages/communications/help-center/ticket/categories/index")
  )
);
const TicketCannedResponses = Loadable(
  lazy(() =>
    import("src/pages/communications/help-center/ticket/cannedResponse/index")
  )
);
const TicketPriorities = Loadable(
  lazy(() =>
    import("src/pages/communications/help-center/ticket/prioritys/index")
  )
);
const TicketView = Loadable(
  lazy(() =>
    import("src/pages/communications/tickets/viewTickets/index.js")
  )
);

const helpCenter = {
  path: "help-center",
  children: [
    {
      index: true,
      element: <Navigate to="tickets" />,
    },
    {
      path: "tickets",
      element: <HelpCenterTicket />,
      children: [
        { index: true, element: <Navigate to="all" /> },
        { path: ":type", element: <TicketDashboard title="All Tickets" /> },

        {
          path: "test",
          children: [
            {
              path: "department",
              element: <TicketDepartment />,
            },
            {
              path: "categories",
              element: <TicketCategories />,
            },
            {
              path: "canned-responses",
              element: <TicketCannedResponses />,
            },
            {
              path: "priorities",
              element: <TicketPriorities />,
            },
          ],
        },

        { path: ":type/:id", element: <TicketView /> },
      ],
    },
  ],
};

export default helpCenter;
